import { render, staticRenderFns } from "./BpuTemplateEdit.vue?vue&type=template&id=40630108&scoped=true"
import script from "./BpuTemplateEdit.vue?vue&type=script&lang=js"
export * from "./BpuTemplateEdit.vue?vue&type=script&lang=js"
import style0 from "./BpuTemplateEdit.vue?vue&type=style&index=0&id=40630108&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40630108",
  null
  
)

export default component.exports